import React, { useMemo } from 'react';
import { DropDown } from '~/components';
import { Link } from 'react-router-dom';
import { MdAssignment, MdAssignmentTurnedIn, MdDescription } from 'react-icons/md';
import { useAuth } from '~/hooks';
import { auth } from '~/util';


const NextStepCell = ({ data, ...rest }) => {
    const { hasRole, user } = useAuth();

    const viewLink = useMemo(() => {
        return hasRole(auth.ROLES.FIRM_USER)
            ? `/policySearchRequest/${data.id}`
            : `/policySearch/${data.id}`;
    }, [data, user]);

    return (
        <span {...rest}>
            <DropDown
                wrapperClass="rounded-md border bg-white z-20 filter drop-shadow-xl right-1/4 top-full mt-1"
                iconClass="text-white ml-2"
                iconSize='1.25em'
                buttonClass="py-1 pl-3 pr-2 bg-blue-50 text-white focus:outline-none rounded-full flex items-center justify-center"
                text='Actions'>
                <section className="flex flex-col items-stretch w-48 text-gray-80">
                    <p className="font-semibold text-sm p-4 py-2">Action</p>
                    <Link to={viewLink} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <MdDescription />
                        <span className="ml-2 ">View Request</span>
                    </Link>
                    <Link to="/preliminaryopinion/0/propertyInfo" className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <MdAssignment />
                        <span className="ml-2">Create PTO</span>
                    </Link>
                    <Link to="/StraightFinal/0/propertyInfo" className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <MdAssignment />
                        <span className="ml-2">Create PTO</span>
                    </Link>
                    <Link to="/" className="py-2 px-4 hover:bg-blue-10 flex items-center">
                        <MdAssignmentTurnedIn />
                        <span className="ml-2 ">Create FTO</span>
                    </Link>
                </section>
            </DropDown>
        </span>
    );
};

export default NextStepCell;